export class scheduled_task {
    public name!: string;
    public description!: string;
    public enabled!: boolean;
    public interval_seconds!: number;
    public is_running!: boolean;
    public last_start_utc: string | null = null;
    public last_end_utc: string | null = null;
    public last_success: boolean | null = null;
    public last_error: string | null = null;
    public next_run_utc: string | null = null;
    public run_count: number = 0;

    constructor(src?: any) {
        if (src) {
            Object.assign(this, src);
        }
    }
}
